/* eslint-disable */
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store'

import groups from './groups'
import courses from './courses'
import timesheets from './timesheets'
import tutors from './tutors'
import booths from './booths'
import schedules from './schedules'
import students from './students'
import applications from './applications'
import mails from './mails'
import evaluations from './evaluations'
import unfinishedTasks from './unfinishedTasks'
import deadlines from './deadlines'
import lessons from './lessons'
import clockIns from './clockIns'
import extras from './extras'

import NotFound from '@/components/pages/error/NotFound.vue'
import OldLMSData from '@/components/pages/error/OldLMSData.vue'
import Login from '@/components/pages/Login.vue';
import Home from '@/components/pages/Home.vue';
import DashboardRouter from '@/components/pages/mypage/index.vue';
import Dashboard from '@/components/pages/mypage/Dashboard.vue';
import Information from '@/components/pages/mypage/Information.vue';

Vue.use(VueRouter);

export default function () {
  const routes = [
    //main
    {
      path:'/',
      component: Home,
      name: 'Home',
      redirect: 'dashboard',
      children: [
        groups,
        courses,
        timesheets,
        tutors,
        booths,
        schedules,
        students,
        applications,
        mails,
        evaluations,
        unfinishedTasks,
        deadlines,
        lessons,
        clockIns,
        extras,
        {
          path: '/dashboard',
          name: 'DashboardRouter',
          component: DashboardRouter,
          children: [
            {
              path: '/dashboard',
              component: Dashboard,
              name: 'Dashboard',
              meta: {
                acceptRoles: ['senior', 'admin', 'partTimer', 'tutor'],
              },
            },
            {
              path: '/dashboard/:id/information',
              component: Information,
              name: 'Information',
              // meta: {
              //   acceptRoles: ['tutor'],
              // },
            },
          ]
        },
      ]
    },
    //login
    {
      path: '/login',
      component: Login,
      name:'Login',
      meta: {
        unnecessaryAuth: true,
      },
    },
    // Not Found
    {
      path: '*',
      component: NotFound,
    },
    // Old LMS 
    {
      path: '/oldlmsdata',
      component: OldLMSData,
      name: 'OldLMSData',
    },
  ];

  const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    }
  });

  // 認証チェック
  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.unnecessaryAuth !== true) && !store.state.auth.token) {
      // 認証が必要、かつ認証トークンがない場合
      next({ path: '/login', query: { redirect: to.fullPath } });
    } else if (_.has(to.meta, 'acceptRoles')) {
      // 権限別認証処理
      const acceptRoles = to.meta.acceptRoles
      const auth = store.state.auth?.profile?.authority

      if (_.indexOf(acceptRoles, auth) !== -1) {
        next()
      } else {
        next({ name: 'Home' })
      }
    } else {
      next();
    }
  });

  return router;
}
